import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectors, sliceKeys } from '../../../../model';

const { createRelatedRoomsCountSelector } = selectors[sliceKeys.houses];

const InfoBlock = ({ room }) => {
  const selectRoomsCount = useMemo(
    () => createRelatedRoomsCountSelector(room),
    [room]
  );

  const count = useSelector(selectRoomsCount);

  return <span>Связанных: {count}</span>;
};

export default InfoBlock;
